module.exports = __webpack_public_path__ + "static/media/NA.98748ec2.png";